var _defs, _circle, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnAyuda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n\n      .st1 {\n        fill: #00733a;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 44.5,
    cy: 44.5,
    r: 44.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.51,32.99c.5-.08.95-.02,1.39.24l15.43,9.66c1.14.82,1.14,2.41,0,3.23l-15.43,9.66c-1.3.74-2.85-.11-2.92-1.6v-19.48c.07-.81.74-1.58,1.53-1.71h0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 20.73,
    y: 20.73,
    width: 47.54,
    height: 47.54,
    rx: 10.65,
    ry: 10.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnAyuda);
export default __webpack_public_path__ + "static/media/btnAyuda.9ca01e0bbfb46d3b51a2339aa511f63f.svg";
export { ForwardRef as ReactComponent };